// index.js — scenario registry for the map-editor demo harness (src/dev/mapDemo).
import { doc as dprkRussiaDoc, META as dprkRussiaMeta } from './dprkRussia';
import { doc as iranUsaDoc, META as iranUsaMeta } from './iranUsa';
import { doc as ukraineRussiaDoc, META as ukraineRussiaMeta } from './ukraineRussia';

export const SCENARIOS = [
    { meta: dprkRussiaMeta, doc: dprkRussiaDoc },
    { meta: iranUsaMeta, doc: iranUsaDoc },
    { meta: ukraineRussiaMeta, doc: ukraineRussiaDoc },
];

export function getScenario(id) {
    return SCENARIOS.find((s) => s.meta.id === id) || SCENARIOS[0];
}
